import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';

export const KrDialog = ({
  title,
  subtitle,
  children,
  closeDialog,
  buttons,
  titleButtons,
  maxWidth = 'md',
  fullWidth = true,
  sx,
}) => {
  return (
    <Dialog
      sx={{
        '.MuiCardHeader-title': {
          fontSize: '1rem',
        },
        '.MuiCardHeader-root': {
          paddingBottom: 0,
        },
        '.MuiCardContent-root': {
          padding: 2,
        },
        '.MuiFormControl-root': {
          margin: 0,
        },
        ...sx,
      }}
      onClose={() => closeDialog()}
      open={true}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      <DialogTitle variant="h5">
        <Stack direction={'row'}>
          <Stack direction={'column'}>
            {title}
            {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
          </Stack>
          <Stack marginLeft={'auto'} direction={'row'}>
            {React.Children.toArray(titleButtons)}
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack gap={2}>{children} </Stack>
      </DialogContent>
      {buttons && <DialogActions>{React.Children.toArray(buttons)}</DialogActions>}
    </Dialog>
  );
};
